// tslint:disable:max-classes-per-file
var OpportunityUpMarketLoadConfigVm = /** @class */ (function () {
    function OpportunityUpMarketLoadConfigVm() {
        this.oppUpVoyId = '';
        this.siteId = '';
        this.siteName = '';
        this.materialId = '';
        this.materialDesc = '';
        this.loadSize = 0;
        this.timeWindowStart = '';
        this.timeWindowEnd = '';
        this.sourceType = '';
        this.vendorId = '';
        this.vendorName = '';
        this.carrierId = '';
        this.carrierName = '';
    }
    return OpportunityUpMarketLoadConfigVm;
}());
export { OpportunityUpMarketLoadConfigVm };
var OpportunityUpMarketLoadConfig = /** @class */ (function () {
    function OpportunityUpMarketLoadConfig() {
        this.id = '';
        this.siteId = '';
        this.siteName = '';
        this.materialId = '';
        this.materialDesc = '';
        this.timeWindow = '';
        this.sourceType = '';
        this.vendorId = '';
        this.vendorName = '';
        this.carrierId = '';
        this.carrierName = '';
    }
    return OpportunityUpMarketLoadConfig;
}());
export { OpportunityUpMarketLoadConfig };
var CreateOpportunityUpMarketLoadConfig = /** @class */ (function () {
    function CreateOpportunityUpMarketLoadConfig() {
        this.siteId = '';
        this.materialId = '';
        this.timeWindow = '';
        this.sourceType = '';
        this.vendorId = '';
        this.carrierId = '';
    }
    return CreateOpportunityUpMarketLoadConfig;
}());
export { CreateOpportunityUpMarketLoadConfig };
var UpdateOpportunityUpMarketLoadConfig = /** @class */ (function () {
    function UpdateOpportunityUpMarketLoadConfig() {
        this.id = '';
        this.siteId = '';
        this.materialId = '';
        this.timeWindow = '';
        this.sourceType = '';
        this.vendorId = '';
        this.carrierId = '';
    }
    return UpdateOpportunityUpMarketLoadConfig;
}());
export { UpdateOpportunityUpMarketLoadConfig };
